export enum ASSETS_TYPE {
  MOBILE = 'mobile-assets',
  FIXED = 'fixed-assets',
  ALL = 'all',
}

export enum ASSETS_PREVIEW {
  MAP = 'map',
  BI = 'business-insights',
  ASSETS = 'assets',
  MAINTENANCE_DATA = 'maintenance-data',
  ALARMS = 'alerts-events-data',
  ALL_ASSETS = 'all',
  UNASSIGNED = 'all-unassigned',
  OPERATOR_PROFICIENCY = 'operator-proficiency',
}

export enum ASSET_STUDIO {
  DIAGNOSTICS = 'diagnostics',
  SENSOR_DATA = 'sensors-data',
  SENSOR_DATA_SUBCOMP = 'sensors-data-sc',
  SENSOR_DATA_COMP = 'sensors-data-comp',
  VISUAL_AI = 'visual-ai',
  OIL_REPORT = 'oil-report',
  MAINTENANCE_DATA = 'maintenance-data',
  ALL_COMPONENTS = 'all-components',
  UNASSIGNED = 'all-unassigned',
  REPORTS = 'reports',
  ALARMS = 'alarms',
  ALL_FORMULAS = 'custom-formulas',
}

export enum SENSOR_DATA_INNER_TABS {
  SENSOR_FUSION = 'sensorFusion',
  SEPECTRUM = 'spectrum',
  WAVEFORM = 'waveform',
  OIL_REPORT = 'oilReports',
}

export enum VISUAL_AI_INNER_TABS {
  BELT_DEFECTS = 'belt-defects',
  BELT_MISALIGNMENT = 'belt-misalignment',
}

// todo: Move to other util
export enum SENSOR_FUSION_DATA_LAYERS {
  AI_TREND = 'AI Trend',
  SENSORS = 'sensors',
  ALARMS = 'alarm',
  MAINTENANCE = 'maintenance',
  OIL_REPORT = 'oil',
  COOLANT = 'coolant',
  SPECTRUM = 'spectrum',
  SPECTRUM_ANALYSIS = 'spectrum_analysis',
  WAVEFORM = 'waveform',
  beltMisalignment = 'beltMisalignment',
  componentEvidence = 'componentEvidence',
  rockSize = 'rockSize',
}

export enum FILTER_PARAMS {
  ASSETS_PREVIEW = 'assetsPreview',
  ASSETS_TYPE = 'assetsType',
  ASSET_STUDIO = 'assetStudio',
  GENERAL_SEARCH = 'search',
  SELECTED_COMPONENT = 'selectedComponent',
  SELECTED_ASSET = 'selectedAsset',
  TAB = 'tab',
  SELECTED_FORMULA = 'selectedFormula',
  SELECTED_DIAGNOSTIC = 'selectedDiagnostic',
  SENSOR_DATA = 'sensorData',
  ASSETS_SECTION = 'assetsSection',
  EVIDENCE_RESOURCE_ID = 'evidenceResourceId',
}

export enum ASSETS_PREVIEW_INNER_TABS {
  OVERVIEW = 'overview',
  FAULTS = 'faults',
  EXPERTS = 'experts',
}

export enum PORTAL_TARGETS {
  ASSETS_PREVIEW_TABS_CONTAINER = 'assets-preview-tabs-container',
  ASSETS_SEARCH_CONTAINER = 'assets-search-container',
}
